// src/pages/unauthorized/Unauthorized.jsx
import React, { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import './Unauthorized.css'; // Optional styling file
import { useAuth } from '../../AuthContext';
import { Button } from 'react-bootstrap';

const Unauthorized = () => {
  const { logout, userRole, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
      const performLogout = async () => {
        
      };
  
      performLogout();
    }, [logout]);

  const logoutUser = async () => {
    try {
      await logout();
      toast.success('You have been successfully logged out');
      // Redirect to login after a brief delay
      setTimeout(() => navigate('/', { replace: true }), 1500);
    } catch (error) {
      toast.error('Logout failed. Please try again.');
      navigate(-1); // Go back to previous page if logout fails
    }
  }

  return (
    <div className="unauthorized-container">
      <ToastContainer />
      <h1>403 - Unauthorized Access</h1>
      <p>You don't have permission to access this page. {userRole}</p>
      <div className="actions">
        <Button className='btn-primary' onClick={() => logoutUser()}>
          Try Again
        </Button>
      </div>
    </div>
  );
};

export default Unauthorized;